/**
 * One place to decide whether a given encounter tab is "filled enough"
 * to show a checkmark on the rail. Keep predicates conservative — a
 * checkmark should feel earned, not given away.
 */
export function isTabComplete(key, encounter, patient) {
    if (!encounter) return false;
    const nonEmpty = (s) => typeof s === 'string' && s.trim().length > 0;
    switch (key) {
        case 'patient':
            return Boolean(patient?.fName || patient?.lName);
        case 'allergies': {
            const list = patient?.allergies || patient?.medicalHistory?.allergies || [];
            return list.length > 0;
        }
        case 'vitals':
            return (encounter.vitals || []).length > 0;
        case 'chiefComplaint':
            return nonEmpty(encounter.chiefComplaint);
        case 'hopi':
            return nonEmpty(encounter.historyOfPresenting);
        case 'currentMedications':
            return (encounter.currentMedications || []).length > 0;
        case 'pmh':
            return (encounter.pastMedicalHistory || []).length > 0;
        case 'psh':
            return (encounter.pastSurgicalHistory || []).length > 0;
        case 'previousInvestigations':
            return (encounter.previousInvestigations || []).length > 0
                || Boolean(encounter.previousInvestigationsNone);
        case 'documents':
            return (encounter.documents || []).length > 0;
        case 'physicalExam':
            return (encounter.physicalExam || []).some(
                (r) => r.status === 'normal' || r.status === 'abnormal'
            );
        case 'diagnoses':
            return (encounter.diagnoses || []).length > 0;
        case 'investigations':
            return (encounter.investigations || []).length > 0;
        case 'treatment':
            return (encounter.treatment || []).length > 0
                || Boolean(encounter.treatmentNone)
                || nonEmpty(encounter.procedureNotes);
        case 'workStatus':
            return Boolean(encounter.workStatus?.status);
        case 'summary':
            return encounter.status === 'finalized';
        default:
            return false;
    }
}
